import * as React from 'react';
import {observer} from 'mobx-react';
import {style} from 'typestyle';
import {RatioTile} from './ratio-tile';
import {ResponsiveImageTile} from './responsive-image-tile';
import {ImagePreloader} from '../types/fn';


export interface ImageStackProps {
  className?: string;
  top: string;
  middle: string;
  bottom: string;
  preload: ImagePreloader;
}

export const ImageStack = observer<ImageStackProps>(
  ({ className, top, middle, bottom, preload }) => (
    <RatioTile className={className}>
      <div className={styles.container}>
        <ResponsiveImageTile
          identity={bottom}
          preload={preload}
        />
        <ResponsiveImageTile
          identity={middle}
          preload={preload}
        />
        <ResponsiveImageTile
          identity={top}
          preload={preload}
        />
      </div>
    </RatioTile>
  )
);


const styles = {
  container: style({
    $nest: {
      '&> div': {
        position: 'absolute',
        width: 'calc(60%)',
        boxShadow: '5px 5px 15px 0 rgba(0, 0, 0, 0.17)'
      },
      '&> div:nth-child(1)': {
        zIndex: 1,
        transform: 'translate3d(50%, 10%, 0)'
      },
      '&> div:nth-child(2)': {
        zIndex: 2,
        transform: 'translate3d(30%, 40%, 0)'
      },
      '&> div:nth-child(3)': {
        zIndex: 3,
        transform: 'translate3d(10%, 20%, 0)'
      }
    }
  })
};